const groupFinTermsSearchActions = {
  GROUP_FIN_TERMS_SEARCH_INIT_STATE_SET: 'GROUP_FIN_TERMS_SEARCH_INIT_STATE_SET',
  GROUP_FIN_TERMS_SEARCH_PROP_UPDATE: 'GROUP_FIN_TERMS_SEARCH_PROP_UPDATE',
  GROUP_FIN_TERMS_SEARCH_PROP_DELETE: 'GROUP_FIN_TERMS_SEARCH_PROP_DELETE'
};
export default groupFinTermsSearchActions;
